export const TICKETMASTER_BASE_URL = 'https://www.ticketmaster.com'
export const TICKETMASTER_CAME_FROM = 'CAMEFROM=CFC_PREMIER_LACROSSE_LEAGUE_WEB_WEB_WEB'